import { render } from "./Settings-JailCallMenuEditor.vue?vue&type=template&id=1495c092&scoped=true"
import script from "./Settings-JailCallMenuEditor.vue?vue&type=script&lang=js"
export * from "./Settings-JailCallMenuEditor.vue?vue&type=script&lang=js"

import "./Settings-JailCallMenuEditor.vue?vue&type=style&index=0&id=1495c092&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1495c092"]])

export default __exports__